
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getOnepublicacindeestudior78or } from '../../api/publicacindeestudior78or.api'
import {customobtenerunarchivogwx58_697684c0a85c3d434df35ef6 } from '../../api/pdfdeestudioszlzwd.api'

import './visualizacindeunestudio2mm3bj.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pvisualizacindeunestudio2mm3bj = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_6974615ca85c3d434df35bd2, setLoftyEndpoint_6974615ca85c3d434df35bd2] = useState({});
		const [loftyres_697684c0a85c3d434df35ef6_component_i9cqp, setloftyres_697684c0a85c3d434df35ef6_component_i9cqp] = useState({});


useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_6974615ca85c3d434df35bd2 = await getOnepublicacindeestudior78or({ _id: match.params.id, token: loftytoken || 'asdsa' });
			setLoftyEndpoint_6974615ca85c3d434df35bd2(loftyres_6974615ca85c3d434df35bd2.data);
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customobtenerunarchivogwx58_697684c0a85c3d434df35ef6({
					publicacioneohp: match.params.id,
				});
				setloftyres_697684c0a85c3d434df35ef6_component_i9cqp(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id697461938e5aed52dc8f2051" >

      <div id="i9ol" className="">
      
      <div id="icjbu5" className="">
      
      <img
        className=""
        id="iwbvf5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhcxkni.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ipwig4" className="">
      
        <a
          target=""
          className=""
          id="idtfhs"
          href="/estudios"
        >
          
    <div id="ifgmx9" className="">
    <>Estudios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ivw47x"
          href={`/contact`}
        >
          
    <div id="iv1mlt" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/acerca"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/estudios"
        type=""
      >
        <>Estudios</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contact"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ifgm" className="">
      
      <div id="irers" className="">
      
        <a
          target=""
          className=""
          id="iuuhyl"
          href="#"
        >
          
      <span className="" id="iy1fm9">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
        <div id="iop9j" className="">
        
        <div className="" id="ijkyr">
          
          <div className="" id="iyuwz">
            {loftyendpoint_6974615ca85c3d434df35bd2?.titulo2lvs3}
          </div>
          
        </div>
        
        <div className="" id="it22f">
          
          <div className="" id="">
            {loftyendpoint_6974615ca85c3d434df35bd2?.descripcincortav6uva}
          </div>
          
        </div>
        
      <div id="ijjro" className="">
      
        <img
          className=""
          id="ir83c"
          alt=""
          src={loftyendpoint_6974615ca85c3d434df35bd2.loftyUrl}
        />
        
      </div>
      
        <div className="" id="ikw5h">
          
          <LoftyEditorJsReadOnly id="iwlcw" className="" defaultValue={loftyendpoint_6974615ca85c3d434df35bd2.contenidon7g82} />
          
        </div>
        
        <div id="i9cqp" className="">
        
      <div id="ih4ii" className="">
      
        <button
          className=""
          id="ikhmt"
          onClick={async () => {
		const res = await fetch(loftyres_697684c0a85c3d434df35ef6_component_i9cqp?.loftyUrl);
      const blob = await res.blob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'archivo.pdf';
      a.click();
      URL.revokeObjectURL(url);
	  }}
        >
          
      <span className="" id="i4n5c">
        <>Descargar Estudio</>
      </span>
      
        </button>
        
      </div>
      
        </div>
        
        </div>
        
      </div>
      
      <div id="ii5t" className="">
      
      <div id="id4e2" className="">
      
      <div className="" id="iglijz">
        <>Copyright © 2025 M2GlobalInsigths ORG</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pvisualizacindeunestudio2mm3bj);
  
